import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Navbar from "./../Components/Navbar";
import Announcement from "./../Components/Announcement";
import NewsLatter from "./../Components/NewsLatter";
import Footer from "./../Components/Footer";
import { Add, Remove } from "@mui/icons-material";
import { mobile, tab } from "./../Responsive";
import { useLocation } from "react-router-dom";
import { publicRequest } from "./../requestMethod";
import { addProduct } from "../redux/cartRedux";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Container = styled.div``;

const Wrapper = styled.div`
  padding: 50px;
  display: flex;
  ${tab({ padding: "10px", flexDirection: "column", })}
`;

const ImgContainer = styled.div`
  flex: 1;
  text-align: center;
`;

const Image = styled.img`
  width: 60%;

  ${"" /* height: 90%; */}
  object-fit: cover;
  ${mobile({ height: "40vh" })}
`;

const InfoContainer = styled.div`
  flex: 1;
  padding: 0px 50px;
  ${tab({ padding: "10px", textAlign: "-webkit-center" })}
`;

const Title = styled.h1`
  font-weight: 200;
`;

const Desc = styled.p`
  margin: 20px 0px;
`;

const Price = styled.span`
  font-weight: 100;
  font-size: 40px;
`;
const FilterContainer = styled.div`
  width: 50%;
  margin: 30px 0px;
  display: flex;
  justify-content: space-between;
  ${mobile({ width: "100%" })}
`;
const Filter = styled.div`
  display: flex;
  align-items: center;
`;
const FilterTitle = styled.span`
  font-size: 20px;
  font-weight: 200;
`;

const FilterColor = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin: 0px 5px;
  cursor: pointer;
  border: 1px solid gray;
`;

const FilterSize = styled.select`
  margin-left: 10px;
  padding: 5px;
`;

const FilterSizeOption = styled.option``;

const AddContainer = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mobile({ width: "100%" })}
`;

const AmountContainer = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
`;
const AllProducts = styled.div`
  color: white;
  background-color: teal;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  padding: 5px;
  width: 10rem;
  text-align: center;
`;
const Br = styled.br``;

const Amount = styled.span`
  width: 30px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid teal;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 5px;
`;

const Button = styled.button`
  padding: 15px;
  border: 2px solid teal;
  background-color: white;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    background-color: #f8f5f5;
  }
`;

const Product2 = () => {
  const LoggedInUser = useSelector((state) => state.user.currentUser);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const [product, setProduct] = useState({});
  const [quantity, setQuantity] = useState(1);
  // const [color, setColor] = useState("");
  const [size, setSize] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const getProduct = async () => {
      try {
        const res = await publicRequest.get("/products/find/" + id);

        setProduct(res.data);

        // console.log("product2", res);
      } catch (err) {
        // console.log("product2", err);
      }
    };
    getProduct();
  }, [id]);

  const handleQuantity = (type) => {
    if (type === "dec") {
      quantity > 1 && setQuantity(quantity - 1);
    } else {
      setQuantity(quantity + 1);
    }
  };
  const handleClick = () => {
    dispatch(addProduct({ ...product, quantity, size }));
  };

  return (
    <>
      <Container>
        <Navbar />
        <Announcement />
        <Wrapper>
          <ImgContainer>
            <Image src={product.img} />
          </ImgContainer>
          <InfoContainer>
            <Title>{product.title} </Title>
            <Desc>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi
              accusantium doloribus esse iste labore omnis aperiam pariatur
              laborum, ea delectus sed animi reiciendis qui quae fugit, itaque
              libero, velit unde.
            </Desc>
            <Price>$ {product.price}</Price>
            <FilterContainer>
              <Filter>
                <FilterTitle>Color</FilterTitle>
                <FilterColor color={product.color} />
                {/* {product.color?.map((c) => (
                  <FilterColor color={c} key={c} onClick={()=> setColor(c)} />
                ))} */}
              </Filter>
              <Filter>
                <FilterTitle>Size</FilterTitle>
                <FilterSize onChange={(e) => setSize(e.target.value)}>
                  {product.size?.map((s) => (
                    <FilterSizeOption key={s}> {s} </FilterSizeOption>
                  ))}
                </FilterSize>
              </Filter>
            </FilterContainer>
            <AddContainer>
              <AmountContainer>
                <Remove onClick={() => handleQuantity("dec")} />
                <Amount>{quantity}</Amount>
                <Add onClick={() => handleQuantity("inc")} />
              </AmountContainer>
              <Button onClick={handleClick}>ADD TO CART</Button>
            </AddContainer>
            <Br />
            <AllProducts>
              <Link style={{ color: "white" }} to="/cart">
                See your Products
              </Link>
            </AllProducts>
          </InfoContainer>
        </Wrapper>
        <NewsLatter />
        <Footer />
      </Container>
    </>
  );
};

export default Product2;
